import React, { useState } from 'react';

const CONTACT_EMAIL = 'jimmy.lagattuta@gmail.com';

const KeywordFooter = () => {
  const currentYear = new Date().getFullYear();
  const [copiedEmail, setCopiedEmail] = useState(false);

  const handleCopyEmail = async () => {
    try {
      await navigator.clipboard.writeText(CONTACT_EMAIL);
      setCopiedEmail(true);

      window.setTimeout(() => {
        setCopiedEmail(false);
      }, 2200);
    } catch (error) {
      console.error('Unable to copy contact email:', error);
      setCopiedEmail(false);
    }
  };

  return (
    <footer className="relative z-10 mt-auto w-full overflow-hidden border-t border-cyan-300/10 bg-slate-950 text-slate-300">
      <div className="absolute inset-0 bg-[radial-gradient(circle_at_12%_0%,rgba(34,211,238,0.16),transparent_32%),radial-gradient(circle_at_88%_20%,rgba(59,130,246,0.14),transparent_34%),linear-gradient(135deg,rgba(2,6,23,0.98),rgba(15,23,42,0.96),rgba(8,47,73,0.78))]" />

      <div className="absolute inset-0 bg-[linear-gradient(rgba(255,255,255,0.03)_1px,transparent_1px),linear-gradient(90deg,rgba(255,255,255,0.03)_1px,transparent_1px)] bg-[size:44px_44px] opacity-20" />

      <div className="absolute left-[-8rem] top-[-6rem] h-72 w-72 rounded-full bg-cyan-400/20 blur-3xl" />
      <div className="absolute bottom-[-8rem] right-[-8rem] h-96 w-96 rounded-full bg-blue-500/20 blur-3xl" />

      <div className="relative mx-auto w-full max-w-7xl px-4 py-10 sm:px-6 lg:px-8">
        <div className="grid gap-8 lg:grid-cols-[minmax(0,0.8fr)_minmax(0,1.2fr)] lg:items-start">
          <div>
            <p className="text-xs font-black uppercase tracking-[0.35em] text-cyan-300">
              Subtitle Tsunami
            </p>

            <h2 className="mt-3 max-w-xl text-2xl font-black tracking-tight text-white sm:text-3xl">
              English To Spanish Subtitles
            </h2>

            <div className="mt-6 inline-flex rounded-full border border-cyan-300/20 bg-cyan-400/10 px-4 py-2 text-[11px] font-black uppercase tracking-[0.18em] text-cyan-100 shadow-lg shadow-cyan-950/20">
              Subtitle Workflow
            </div>
          </div>

          <div className="grid gap-5 text-sm leading-7 text-slate-300">
            <p>
              Generate English to Spanish subtitles, review the output, and download the final video from one clean workflow.
            </p>

            <p>
              Built for creators, educators, and businesses translating videos they own or have permission to use.
            </p>

            <div className="grid gap-4 md:grid-cols-2">
              <div>
                <p className="mb-2 text-xs font-black uppercase tracking-[0.2em] text-cyan-300/80">
                  Product
                </p>

                <nav
                  aria-label="Footer product links"
                  className="flex flex-wrap items-center gap-2 text-sm font-black"
                >
                  <a
                    href="/"
                    className="rounded-full border border-cyan-300/15 bg-cyan-300/5 px-3 py-1.5 text-cyan-100/90 transition hover:-translate-y-0.5 hover:border-cyan-200/60 hover:bg-cyan-300/15 hover:text-white"
                  >
                    Home
                  </a>

                  <a
                    href="/english-to-spanish-subtitle-generator"
                    className="rounded-full border border-cyan-300/15 bg-cyan-300/5 px-3 py-1.5 text-cyan-100/90 transition hover:-translate-y-0.5 hover:border-cyan-200/60 hover:bg-cyan-300/15 hover:text-white"
                  >
                    Spanish Subtitle Generator
                  </a>

                  <a
                    href="/blog"
                    className="rounded-full border border-cyan-300/15 bg-cyan-300/5 px-3 py-1.5 text-cyan-100/90 transition hover:-translate-y-0.5 hover:border-cyan-200/60 hover:bg-cyan-300/15 hover:text-white"
                  >
                    Blog
                  </a>
                </nav>
              </div>

              <div>
                <p className="mb-2 text-xs font-black uppercase tracking-[0.2em] text-cyan-300/80">
                  Legal
                </p>

                <nav
                  aria-label="Footer legal links"
                  className="flex flex-wrap items-center gap-2 text-sm font-black"
                >
                  <a
                    href="/terms"
                    className="rounded-full border border-cyan-300/15 bg-cyan-300/5 px-3 py-1.5 text-cyan-100/90 transition hover:-translate-y-0.5 hover:border-cyan-200/60 hover:bg-cyan-300/15 hover:text-white"
                  >
                    Terms
                  </a>

                  <a
                    href="/privacy"
                    className="rounded-full border border-cyan-300/15 bg-cyan-300/5 px-3 py-1.5 text-cyan-100/90 transition hover:-translate-y-0.5 hover:border-cyan-200/60 hover:bg-cyan-300/15 hover:text-white"
                  >
                    Privacy
                  </a>

                  <a
                    href="/copyright"
                    className="rounded-full border border-cyan-300/15 bg-cyan-300/5 px-3 py-1.5 text-cyan-100/90 transition hover:-translate-y-0.5 hover:border-cyan-200/60 hover:bg-cyan-300/15 hover:text-white"
                  >
                    Copyright
                  </a>
                </nav>
              </div>
            </div>

            <div className="rounded-2xl border border-cyan-300/10 bg-slate-950/40 px-4 py-3">
              <p className="text-xs font-bold uppercase tracking-[0.18em] text-cyan-300/80">
                Contact Email
              </p>

              <div className="mt-2 flex flex-col gap-2 sm:flex-row sm:items-center">
                <p className="break-all text-sm font-extrabold text-cyan-100">
                  {CONTACT_EMAIL}
                </p>

                <button
                  type="button"
                  onClick={handleCopyEmail}
                  className="inline-flex w-fit items-center justify-center rounded-xl border border-cyan-300/20 bg-cyan-300/10 px-3 py-1.5 text-xs font-black uppercase tracking-[0.12em] text-cyan-100 transition hover:-translate-y-0.5 hover:border-cyan-200/60 hover:bg-cyan-300/15 hover:text-white"
                >
                  {copiedEmail ? 'Copied' : 'Copy Email'}
                </button>
              </div>
            </div>
          </div>
        </div>

        <div className="mt-9 flex flex-col gap-2 border-t border-white/10 pt-5 text-xs font-bold text-slate-400 sm:flex-row sm:items-center sm:justify-between">
          <p>
            &copy; {currentYear} SubtitleTsunami. All rights reserved.
          </p>

          <p className="text-cyan-200/80">
            Translate. Subtitle. Download....
          </p>
        </div>
      </div>
    </footer>
  );
};

export default KeywordFooter;